import React from "react";
import Loader from "../../Layouts/Loader/Loader";

const Button = ({
  type = "button",
  onClick = () => {},

  className = "",
  disabled = false,
  variant = "primary",
  size = "medium",
  children,
  isLoading = false,
  title = "",
  style,
  ...rest
}) => {
  const baseClass = "builder_button";
  const variantClass = `${variant}`;
  const sizeClass = `${size}`;
  const buttonClassName = `${baseClass} ${variantClass} ${sizeClass} ${className}`.trim();

  const isBtnDisabled = disabled || isLoading;
  return (
    // <button title={title} type={type} onClick={onClick} className={buttonClassName} disabled={disabled} style={style}>
    //   {isLoading ? <Loader style={{ border: "1px solid white" }} width="10px" /> : children}
    // </button>
    <button
      title={title}
      type={type}
      onClick={onClick}
      className={buttonClassName}
      disabled={isBtnDisabled}
      style={style}
      {...rest}
    >
      {isLoading ? <Loader style={{ borderBottomColor: "transparent" }} width="16px" /> : children}
    </button>
  );
};

export default Button;
